/**************************************************************************************************/
/*   File: /src/app/shared/components/plan-type-selector/plan.type.selector.ts                    */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Fri Feb 22 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { Component, EventEmitter, Input, Output } from '@angular/core';

import * as fromModels from '../../models';

/**
 * The plan selector
 */
@Component({
  selector: 'nwpl-frnt-plan-selector',
  templateUrl: './plan.type.selector.html',
  styleUrls: ['./plan.type.selector.scss']
})
export class PlanTypeSelectorComponent {

  /**
   * The plan types array
   */
  @Input() planTypes: fromModels.PlanType[];
  /**
   * The selected plan type code
   */
  @Input() selectedPlan: string;
  /**
   * The is validating
   */
  @Input() isValidating: boolean;
  /**
   * The is validated flag
   */
  @Input() isValidated: boolean;
  /**
   * The id disabled
   */
  @Input() disabled ? = false;
  /**
   * The selected event emitter
   */
  @Output() selected: EventEmitter<string> = new EventEmitter<string>();
  /**
   * The view type 'button' | 'select';
   */
  @Input() viewType: string;


  /**
   * The constructor
   */
  constructor() { }

  /**
   * The select action
   * @param selection The plan type selection
   */
  selectPlanType(selection: string) {
    this.selected.emit(selection);
  }

  /**
   * The selection throug select
   */
  selectPlanTypeSelect(value: string) {
    this.selected.emit(value !== 'undefined' ? value : undefined);
  }

}
